import React, { useRef, useState, useEffect } from 'react';
import './VideoPlayer.sass';
import PlayCircle from '../icons/play-circle.svg'

const VideoPlayer = ({ src, autoplay }) => {
  const [playing, setPlaying] = useState(autoplay);
  let video = useRef(null);

  useEffect(() => {
    if (video.current) {
      // v.addEventListener("seeked", function() { v.play(); }, true);
      video.current.addEventListener('play', () => start(), true);
      video.current.addEventListener('pause', () => stop(), true);
    }
  }, []);

  const stop = () => {
    setPlaying(false);
  };

  const start = () => {
    setPlaying(true);
  };

  const play = () => {
    console.log("play")
    if (video.current) {
      if (video.current.paused) {
        video.current.play();
      } else {
        video.current.pause();
      }
    }
  };

  return (
    <div className="VideoPlayer" onClick={play}>
      <div className={playing ? 'overlay hidden' : 'overlay'}>
        <div className="scrim" width="100%" height="100%">
          <img src={PlayCircle} />
        </div>
      </div>
      <video ref={video} src={src} autoPlay={autoplay} />
    </div>
  );
};

export default VideoPlayer;
